import { ErrorMessageMap, RegenerationErrorType } from '../types/types';

export const errorMessages: ErrorMessageMap = {
  [RegenerationErrorType.MISSING_PROJECT_ID]:
    'Project ID could not be found in environment data.',
  [RegenerationErrorType.MISSING_ENVIRONMENT_ID]:
    'Environment ID could not be found in environment data.',
  [RegenerationErrorType.MISSING_ORGANIZATION_ID]:
    'Organization ID could not be determined. Please try accessing this feature directly from the Context ID details page.',
  [RegenerationErrorType.TENANT_NOT_FOUND]:
    'Environment could not be found for this Context ID.',
  [RegenerationErrorType.NO_ANNOTATIONS]:
    'Required project and environment annotations could not be found in environment data.',
  [RegenerationErrorType.GENERAL_ERROR]:
    'An unexpected error occurred during regeneration.',
  [RegenerationErrorType.NO_TENANT_APPLICATIONS]:
    'No environment applications could be found. This may be due to missing permissions or data.',
  [RegenerationErrorType.DATA_RETRIEVAL_ERROR]:
    'Could not retrieve Context ID or environment information. Please try again later.',
};

export const getErrorMessage = (
  errorType: RegenerationErrorType,
  details?: string,
): string => {
  const baseMessage =
    errorMessages[errorType] ||
    errorMessages[RegenerationErrorType.GENERAL_ERROR];
  return details ? `${baseMessage} ${details}` : baseMessage;
};

export const logError = (
  component: string,
  error: Error | unknown,
  context: Record<string, any> = {},
): void => {
  const errorMessage = error instanceof Error ? error.message : String(error);
  const errorStack = error instanceof Error ? error.stack : undefined;

  console.error(`[${component}] Error:`, errorMessage, {
    stack: errorStack,
    ...context,
  });
};
